import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'place',
  standalone: true,
})
export class PlacePipe implements PipeTransform {
  onSite = [
    'intervention_site',
    'Intervention_site_inst',
    'intervention_site_hors_fiche'
  ];
  distance = [
    'intervention_distance',
    'Prestation_distance',
    'Intervention_centre',
    'Intervention_distance_hors_fiche'
  ];

  transform(value: string): string {
    if (value == null) {
      return '';
    }
    if (this.onSite.indexOf(value) !== -1) {
      return 'Intervention sur site';
    } else if (this.distance.indexOf(value) !== -1) {
      return 'Prestation à distance';
    } else {
      return '';
    }
  }
}
